import { Injectable } from '@angular/core';
import { PageType } from '@shared/enums';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageTypeService {
  private readonly pageType$: ReplaySubject<keyof typeof PageType>;

  constructor() {
    this.pageType$ = new ReplaySubject<keyof typeof PageType>(1);
  }

  setPageType(pageType: keyof typeof PageType): void {
    this.pageType$.next(pageType);
  }

  getPageType$(): Observable<keyof typeof PageType> {
    return this.pageType$;
  }
}
